import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useParams } from 'react-router';
import { resetSingleDocument, selectSingleDocument } from '../reducers/gridReducer';
import { fetchSingleDocument } from '../fetch/singleDocument';
import { UserCircleIcon, UserGroupIcon, MapPinIcon, CalendarDaysIcon, ArrowDownCircleIcon, ArrowLeftCircleIcon } from '@heroicons/react/24/solid'
import { selectLangObj } from '../reducers/langReducer';
import { useNavigate } from 'react-router';

function GridPreview({ }) {
    let params = useParams()
    const navigate = useNavigate();

    let id = params.id;

    const dispatch = useDispatch();
    const singleDocument = useSelector(selectSingleDocument);
    const langObj = useSelector(selectLangObj);



    useEffect(() => {

        dispatch(fetchSingleDocument(id));

        return () => {
            dispatch(resetSingleDocument());

        };
    }, []);




    return (
        <div key={params.id} className='w-full h-full backdrop-blur-xl smd:p-6 overflow-auto flex flex-col'>
            <div className='rounded-xl flex flex-col flex-grow flex-shrink' style={{ minHeight: 0, maxHeight: '150%' }}>
                <div className='bg-beige-800 bg-opacity-50 backdrop-blur-xl flex justify-center items-stretch flex-grow relative' style={{ minHeight: '0' }}>
                    <img className='object-contain h-full' src={singleDocument?.линк}></img>

                    <div className={'backdrop-blur-lg absolute top-0 left-0 w-full h-full  transition-all duration-300  ' + singleDocument?.линк ? 'opacity-0' : ' opacity-100'}>

                    </div>
                </div>
                <div className='bg-beige-400 flex flex-col md:flex-row md:justify-between items-stretch gap-3 sm:gap-6 md:gap-12 flex-shrink-0 flex-grow-0'>
                    <div className='flex px-3 md:px-12 py-1 md:py-3  flex-col gap-6  text-slate-700'>
                        <div className='flex items-center gap-1 sm:gap-3 text-sm sm:text-2xl md:text-3xl'>

                            {singleDocument?.наслов}
                        </div>

                        <div className='flex flex-col md:flex-row gap-3 md:gap-6  text-slate-700'>
                            <div className='flex max-sm:flex-col max-sm:items-start  gap-3 md:gap-6 text-slate-700'>

                                <div className='flex items-center gap-3 text-xs sm:text-lg md:text-xl'>

                                    <UserCircleIcon className='size-3 sm:size-4 md:size-6' />
                                    {singleDocument?.прикупио}
                                </div>
                                <NavLink to={"/PeopleOnImage/" + id} end className={"text-blue-900  flex items-center gap-3  text-xs sm:text-lg md:text-xl"}>

                                    <UserGroupIcon className='size-3 sm:size-4 md:size-6 self-start ' />


                                    {singleDocument?.concatenatedNames}
                                </NavLink>
                            </div>
                            {/* <div className='flex flex-col gap-3 md:gap-6  text-slate-700'>
                                <div className='flex items-center  gap-3'>


                                    <MapPinIcon className='size-4' />
                                    {singleDocument?.место}
                                </div>
                                <div className='flex items-center  gap-3'>


                                    <CalendarDaysIcon className='size-4' />
                                    {singleDocument?.датум}
                                </div>
                            </div> */}


                        </div>
                    </div>

                    <div className='flex flex-col sm:flex-row md:flex-col px-3 md:px-12 py-1 md:py-3  gap-3 md:gap-6 text-beige-400 bg-slate-500 items-start sm:items-center md:items-start justify-start'>
                        <div className=' text-sm sm:text-2xl md:text-3xl'>

                            {langObj["Options"]}
                        </div>
                        <div className='flex flex-col sm:flex-row gap-3 md:gap-6 items-start justify-start'>

                            {/* <hr className='w-full border-slate-500'/> */}
                            <button className='transition-all duration-300 hover:scale-110  flex gap-1 items-center bg-beige-400  text-slate-500  font-medium p-1 rounded text-xs sm:text-lg md:text-xl'>
                                <ArrowDownCircleIcon className='size-3 sm:size-4 md:size-6' />
                                {langObj["Download"]}
                            </button>

                            <button onClick={() => navigate(-1)} className='transition-all duration-300 hover:scale-110 flex gap-1 items-center bg-beige-400 text-slate-500 font-medium p-1 rounded  text-xs sm:text-lg md:text-xl'>
                                <ArrowLeftCircleIcon className='size-3 sm:size-4 md:size-6' />
                                {langObj["Back"]}
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default GridPreview;